import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { UserPlus } from "lucide-react";
import { api } from "../../lib/api";
import UserDirectory from "./UserDirectory";

export default function UsersPage() {
  const dashboard = useQuery({ queryKey: ["tech-ops-dashboard"], queryFn: api.getDashboard });
  return <div className="pa-page-stack">
    <div className="pa-title-row"><div><h1>Users</h1><p>Manage user profiles and WhatsApp test recipients.</p></div>
      {dashboard.data?.platform_user.roles.includes("TECH_ADMIN") && <Link className="pa-primary-button" to="/users/new"><UserPlus size={17} /> Create user</Link>}
    </div>
    <UserDirectory />
  </div>;
}
